/**
 * React hook для отправки ссылки привязки Telegram
 * Дата: 27.12.2025 - Создан для TODO-007 (отправка ссылки привязки Telegram)
 * Дата: 10.01.2026 - Добавлен useRequestContact для TODO-012b (Reverse Linking)
 * Связан с: frontend/src/api/linking.ts, frontend/src/components/features/messages/ChatWindow.tsx
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { linkingApi, SendLinkRequest, RequestContactRequest, GenerateLinkRequest } from '../api/linking';

export function useSendTelegramLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SendLinkRequest) => linkingApi.sendLink(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      queryClient.invalidateQueries({ queryKey: ['patient'] });
    },
  });
}

// Дата: 15.01.2026 - TODO-028a: генерация deep link (telegram/max)
export function useGenerateLink() {
  return useMutation({
    mutationFn: (data: GenerateLinkRequest) => linkingApi.generateLink(data),
  });
}

// Дата: 15.01.2026 - TODO-028a: отправка deep link (telegram/max)
export function useSendLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SendLinkRequest) => linkingApi.sendLink(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      queryClient.invalidateQueries({ queryKey: ['patient'] });
      queryClient.invalidateQueries({ queryKey: ['bindings'] });
    },
  });
}

// Дата: 10.01.2026 - Добавлено для TODO-012b (Reverse Linking)
export function useRequestContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: RequestContactRequest) => linkingApi.requestContact(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      queryClient.invalidateQueries({ queryKey: ['patient'] });
      queryClient.invalidateQueries({ queryKey: ['bindings'] });
    },
  });
}

